webpackJsonp([142629428675168],{

/***/ 265:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":3,"edges":[{"node":{"id":"/opt/build/repo/src/content/about.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"About Dynamic Pages","path":"/about","date":null}}},{"node":{"id":"/opt/build/repo/src/content/posts/test-post-2.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Text Post Two","path":"/test-post-2","date":"13 December, 2017"}}},{"node":{"id":"/opt/build/repo/src/content/posts/test-post.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Test Post","path":"/test-post","date":"13 December, 2017"}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-508c9030f7b5a689c03e.js